/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IClasesTecnicas from 'Infotrack@Modelos/smartStock/clasesTecnicas/entidades/clasesTecnicas';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import ClasesTecnicasCM from '../controladorModelo/clasesTecnicasCM';
import { acciones, IEstadoClasesTecnicas } from '../reductorClasesTecnicas';
import ClasesTecnicasVista from '../vista/tablaClasesTecnicasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const clasesTecnicasCM = new ClasesTecnicasCM();

const TableClasesTecnicasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [clasesTecnicass, setClasesTecnicass] = React.useState<IClasesTecnicas[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoClasesTecnicas>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarClasesTecnicas();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarClasesTecnicas = () => {
        manejadorIndicadorCargaGlobal(true);
        clasesTecnicasCM.consultarClasesTecnicasPorFiltro({EmpresaId:idEmpresa}).then((clasesTecnicass) => {
            setClasesTecnicass(clasesTecnicass);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadClasesTecnicas?: IClasesTecnicas) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadClasesTecnicas, tipoFormulario } });
    };

    const confirmarEliminacion = (clasesTecnicas: IClasesTecnicas) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarClasesTecnicas(clasesTecnicas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarClasesTecnicas = (clasesTecnicas: IClasesTecnicas) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        clasesTecnicasCM.eliminarClasesTecnicas(clasesTecnicas).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <ClasesTecnicasVista
            clasesTecnicass={clasesTecnicass}
            cargarClasesTecnicas={cargarClasesTecnicas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableClasesTecnicasCV;
